import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Subscription } from '../models/subscription';
import { GlobalVariable } from '../helpers/settings';

@Injectable({
	providedIn: 'root'
})
export class AppConfigService {
	private config = { ...GlobalVariable };
	public currentUser: Partial<User> = {};
	public currentSubscription: Partial<Subscription>;

	constructor() {}

	load(currentUser, currentSubscription = null) {
		if (currentUser) {
			this.currentUser = currentUser;
			this.currentSubscription = (this.currentUser?.subscription as Subscription) ?? {};
		}
		if (currentSubscription) {
			this.currentSubscription = (currentSubscription as Subscription) ?? {};
		}
		const customAppNames = this.currentSubscription?.customAppNames ?? [];
		for (const key of Object.keys(this.config)) {
			if (customAppNames[key]) {
				// App already Exist
				this.config[key] = {
					...this.config[key],
					title: customAppNames[key].title,
					nickName: customAppNames[key].nickName
				};
			} else {
				this.config[key] = {
					...this.config[key],
					title: this.config[key].title,
					nickName: this.config[key].nickName
				};
			}
		}
	}
	getAllConfig() {
		return this.config;
	}
	getAppsConfig(currentSubscription) {
		this.load(null, currentSubscription);
		return Object.values(this.config)
			.filter((elem: any) => elem?.isApp)
			.map((res: any) => ({
				code: res.code,
				title: res.title,
				name: res.name,
				nickName: res.nickName
			}));
	}
	resetConfig() {
		this.config = { ...GlobalVariable };
		this.currentUser = {};
		this.currentSubscription = {};
	}

	getAppName(appKey: string): string {
		if (appKey === 'STOCK_MANAGEMENT') {
			appKey = 'STOCK';
		}
		return this.config[appKey]?.name || appKey;
	}
	getAppNickName(appKey: string): string {
		if (appKey === 'STOCK_MANAGEMENT') {
			appKey = 'STOCK';
		}
		if (appKey === 'DASHBOARD') {
			appKey = 'Dashboard';
		}
		return this.config[appKey]?.nickName || appKey;
	}
	getAppTitle(appKey: string): string {
		if (appKey === 'STOCK_MANAGEMENT') {
			appKey = 'STOCK';
		}
		return this.config[appKey]?.title || appKey;
	}
}
